"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentProjectionKeys = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ShipmentProjectionKeys = {
    Id: 'id',
    WholesaleOrderId: 'wholesaleOrderId',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    ShipmentItems: 'shipmentItems',
    Status: 'status',
    ExternalId: 'externalId',
    ValidatedDestinationAddress: 'validatedDestinationAddress',
    InputDestinationAddress: 'inputDestinationAddress',
    ShipmentType: 'shipmentType',
    OriginWarehouseId: 'originWarehouseId',
    WarehouseOrderType: 'warehouseOrderType',
    EstimatedPalletDetails: 'estimatedPalletDetails',
    ActualPalletDetails: 'actualPalletDetails',
    Notes: 'notes',
    Packages: 'packages',
    FulfillmentId: 'fulfillmentId',
    Attachments: 'attachments',
    ThirdPartyTransportationEstimations: 'thirdPartyTransportationEstimations',
    FreightInfo: 'freightInfo',
    ShipBy: 'shipBy',
    ShippedAt: 'shippedAt',
    BusinessDaysBeforeSubmission: 'businessDaysBeforeSubmission',
    PickingInstructions: 'pickingInstructions',
    IsUnitPicking: 'isUnitPicking'
};
//# sourceMappingURL=shipment-projection-keys.js.map